(() => {
  if (window.__ssCROTrackingLoaded) return;
  window.__ssCROTrackingLoaded = true;

  const state = {
    events: [],
    product: null
  };

  const readProduct = () => {
    const node = document.querySelector('[data-ss-cro-product]');
    if (!node) return null;
    try { return JSON.parse(node.textContent || '{}'); } catch (_) { return null; }
  };

  const push = (event, payload = {}) => {
    const record = {
      event,
      event_id: 'ss_' + Date.now() + '_' + Math.random().toString(36).slice(2, 9),
      timestamp: new Date().toISOString(),
      ...payload
    };
    state.events.push(record);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(record);
    document.dispatchEvent(new CustomEvent('ss:cro-event', { detail: record }));
    return record;
  };

  const trackView = () => {
    const product = readProduct();
    if (!product || sessionStorage.getItem('ss_view_' + product.product_id)) return;
    state.product = product;
    sessionStorage.setItem('ss_view_' + product.product_id, '1');
    push('ss_view_item', { ecommerce: { items: [product] } });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', trackView, { once: true });
  } else {
    trackView();
  }

  document.addEventListener('shopify:product:view', () => trackView());

  document.addEventListener('shopify:cart:lines-update', (event) => {
    const action = event.action || event.detail?.action;
    if (action !== 'add') return;
    const product = readProduct();
    const promise = event.promise || event.detail?.promise;
    if (promise && typeof promise.then === 'function') {
      promise.then((result) => {
        push('ss_add_to_cart_success', {
          product,
          cart: result?.cart || null,
          source: 'shopify_standard_event'
        });
      }).catch(() => {});
    }
  });

  document.addEventListener('click', (event) => {
    const option = event.target.closest('ss-bundle-selector [data-quantity]');
    if (!option) return;
    push('ss_bundle_selected', {
      product: readProduct(),
      quantity: Number(option.dataset.quantity || 1)
    });
  });

  window.SpiritStonesCRO = {
    debug: () => ({ ...state, dataLayerAvailable: Array.isArray(window.dataLayer) }),
    clearDebug: () => { state.events.length = 0; }
  };
})();